import { styled } from "@mui/material/styles";
import { useEffect, useRef } from "react";

import { ExternalWidgetTicketinghubProps } from "./ExternalWidgetTicketinghub";

const StyledDiv = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: 340,
});

/**
 * The ticketinghub script loads widgetJS and creates an iframe for us to display.
 * We are dynamically attaching a <script> becasue the NextJS <Script> component attaches
 * at the bottom of the body and doesn't allow for us to control where to display in the dom.
 * and adding a <script> tag in the compneent directly is disabled in NextJS
 */
export function Ticketinghub({ widgetId }: Pick<ExternalWidgetTicketinghubProps, "widgetId">) {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current?.querySelector("script")) {
            return;
        }
        const script = document.createElement("script");
        script.src = "https://assets.ticketinghub.com/checkout.js";
        script.dataset.widget = widgetId;
        script.dataset.endpoint = "https://api.ticketinghub.com";
        ref.current?.appendChild(script);
    }, [ref, widgetId]);

    return <StyledDiv ref={ref}></StyledDiv>;
}
